/**
 * Спрайт иконок, перенесённый из docs/mockups.html без изменения форм.
 * Рендерится один раз в начале документа, используется через <Icon name=…>.
 */
export function IconSprite() {
  return (
    <svg style={{ display: 'none' }} aria-hidden="true">
      <symbol id="i-search" viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="7"/>
        <path d="m20 20-3.5-3.5"/>
      </symbol>
      <symbol id="i-settings" viewBox="0 0 24 24">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
        <circle cx="12" cy="12" r="3"/>
      </symbol>
      <symbol id="i-plus" viewBox="0 0 24 24">
        <path d="M12 5v14M5 12h14"/>
      </symbol>
      <symbol id="i-qr" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <path d="M14 14h3v3h-3zM20 14v3M14 20h3M20 20h1"/>
      </symbol>
      <symbol id="i-back" viewBox="0 0 24 24">
        <path d="M19 12H5M11 18l-6-6 6-6"/>
      </symbol>
      <symbol id="i-photo" viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="16" rx="2"/>
        <circle cx="8.5" cy="9.5" r="1.5"/>
        <path d="m4 17 5-5 4 4 3-2 4 4"/>
      </symbol>
      <symbol id="i-camera" viewBox="0 0 24 24">
        <path d="M4 7h3l2-2h6l2 2h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"/>
        <circle cx="12" cy="13" r="4"/>
      </symbol>
      <symbol id="i-pin" viewBox="0 0 24 24">
        <path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z"/>
        <circle cx="12" cy="10" r="2.5"/>
      </symbol>
      <symbol id="i-pick" viewBox="0 0 24 24">
        <path d="M3 21 14 10M8 4c4 0 8 2 11 6-4-1-7 0-9 2-1-3-2-6-2-8zM8 4c-2 3-3 6-2 9"/>
      </symbol>
      <symbol id="i-ruler" viewBox="0 0 24 24">
        <rect x="2" y="8" width="20" height="8" rx="1"/>
        <path d="M7 8v3M12 8v4M17 8v3"/>
      </symbol>
      <symbol id="i-tag" viewBox="0 0 24 24">
        <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z"/>
        <circle cx="8" cy="8" r="1.4"/>
      </symbol>
      <symbol id="i-edit" viewBox="0 0 24 24">
        <path d="M4 20h4L20 8l-4-4L4 16v4zM14 6l4 4"/>
      </symbol>
      <symbol id="i-chevron" viewBox="0 0 24 24">
        <path d="m9 6 6 6-6 6"/>
      </symbol>
      <symbol id="i-x" viewBox="0 0 24 24">
        <path d="M6 6l12 12M18 6 6 18"/>
      </symbol>
      <symbol id="i-refresh" viewBox="0 0 24 24">
        <path d="M21 12a9 9 0 1 1-3-6.7M21 4v5h-5"/>
      </symbol>
      <symbol id="i-filter" viewBox="0 0 24 24">
        <path d="M4 5h16l-6 7v6l-4 2v-8L4 5z"/>
      </symbol>
      <symbol id="i-download" viewBox="0 0 24 24">
        <path d="M12 4v11M8 11l4 4 4-4M4 20h16"/>
      </symbol>
      <symbol id="i-alert" viewBox="0 0 24 24">
        <path d="M12 4 2.5 20h19L12 4zM12 10v4M12 17.5v.5"/>
      </symbol>
      <symbol id="i-check" viewBox="0 0 24 24">
        <path d="M4 12.5 9 17.5 20 6.5"/>
      </symbol>
      <symbol id="i-printer" viewBox="0 0 24 24">
        <path d="M7 9V3h10v6M7 19H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M7 15h10v6H7z"/>
      </symbol>
      <symbol id="i-book" viewBox="0 0 24 24">
        <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2V5zM4 19a2 2 0 0 0 2 2h13"/>
      </symbol>
      <symbol id="i-chart" viewBox="0 0 24 24">
        <path d="M3 3v16a2 2 0 0 0 2 2h16M8 17V10M13 17V5M18 17v-4"/>
      </symbol>
      <symbol id="i-route" viewBox="0 0 24 24">
        <circle cx="6" cy="6" r="2.5"/>
        <circle cx="18" cy="18" r="2.5"/>
        <path d="M8.5 6H14a3 3 0 0 1 0 6h-4a3 3 0 0 0 0 6h5.5"/>
      </symbol>
    </svg>
  );
}

export type IconName =
  | 'search'
  | 'settings'
  | 'plus'
  | 'qr'
  | 'back'
  | 'photo'
  | 'camera'
  | 'pin'
  | 'pick'
  | 'ruler'
  | 'tag'
  | 'edit'
  | 'chevron'
  | 'x'
  | 'refresh'
  | 'filter'
  | 'download'
  | 'alert'
  | 'route'
  | 'chart'
  | 'check'
  | 'printer'
  | 'book';

export function Icon({ name, className = 'icon' }: { name: IconName; className?: string }) {
  return (
    <svg className={className} aria-hidden="true">
      <use href={`#i-${name}`} />
    </svg>
  );
}
